<div class="tw-flex tw-h-full tw-items-center tw-gap-3">
  @if ($any(this).iconName) {
    <div
      class="tw-flex tw-h-12 tw-w-12 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-dt-neutral-300 tw-text-neutral-600"
    >
      <svg class="tw-h-5 tw-w-5">
        <use [attr.xlink:href]="'images/sprite.svg#' + $any(this).iconName"></use>
      </svg>
    </div>
  }

  <div class="tw-flex tw-flex-col tw-items-start tw-justify-center">
    <span
      class="card-selected-name tw-text-sm tw-font-medium tw-text-dt-text-headings tw-text-wrap tw-line-clamp-2"
    >
      {{ title }}
    </span>
    <span class="tw-text-sm tw-font-normal tw-text-dt-text-secondary">
      {{ subtitle }}
    </span>
  </div>
</div>
